// DevHub CUSTOM — the "add an icon before publishing" line inside a DRAFT banner.
//
// The doc starter-kit template gives every new doc a deliberately unfinished-looking
// placeholder icon (/icons/under-construction.svg). While the entity is still a draft
// (spec.lifecycle: preview) and its draeger.com/docs-icon is missing or still that
// placeholder, the DRAFT banner — on the entity page and in the doc reader — carries
// this nudge to swap in the author's own image. Renders nothing for published docs or
// drafts that already have an icon.
import { Entity } from '@backstage/catalog-model';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { Link } from 'react-router-dom';
import { catalogMessages } from '../../i18n/catalog';
import { PLACEHOLDER_DOCS_ICON, isPreview, needsDocsIcon } from './entityHelpers';
import './DocsIconNudge.css';

/** The `draeger.com/docs-icon` section of the DevHub Author's Guide. */
export const AUTHORS_GUIDE_ICON_HREF =
  '/docs/default/component/devhub-authors-guide/annotations/#draegercomdocs-icon';

/** True when a draft banner should carry the icon nudge. */
export function showsDocsIconNudge(entity: Entity): boolean {
  return isPreview(entity) && needsDocsIcon(entity);
}

export const DocsIconNudge = ({ entity }: { entity: Entity }) => {
  const { t } = useTranslationRef(catalogMessages);
  if (!showsDocsIconNudge(entity)) return null;
  return (
    <div className="devhub-docs-icon-nudge">
      <img
        className="devhub-docs-icon-nudge__preview"
        src={PLACEHOLDER_DOCS_ICON}
        alt={t('iconNudge.placeholderAlt')}
        width={32}
        height={32}
      />
      <div className="devhub-docs-icon-nudge__text">
        <strong>{t('iconNudge.title')}</strong>{' '}
        <span>{t('iconNudge.body')}</span>{' '}
        <code className="devhub-docs-icon-nudge__code">
          draeger.com/docs-icon: assets/&lt;file&gt;
        </code>{' '}
        <Link className="devhub-docs-icon-nudge__link" to={AUTHORS_GUIDE_ICON_HREF}>
          {t('iconNudge.guide')}
        </Link>
      </div>
    </div>
  );
};
